import { Country } from '@/models/globalization/country';
import { State } from '@/models/globalization/state';
import { axiosService } from '.';

export default class GlobalizationService {
    public async getCountries(): Promise<Country[]> {
        const response = await axiosService.instance.get('globalization/organization/countries');
        return response.data.map((country: any) => new Country(country));
    }

    public async getStates(countryId: number): Promise<State[]> {
        const response = await axiosService.instance.get(`globalization/organization/states/${countryId}`);
        return response.data.map((state: any) => new State(state));
    }
}

export const globalizationService = new GlobalizationService();
